import React from 'react';
import { motion } from 'framer-motion';
interface HeaderProps {
  onScrollToCatalog?: () => void;
  onBusinessOrder?: () => void;
}
export function Header({
  onScrollToCatalog,
  onBusinessOrder
}: HeaderProps) {
  return <header className="w-full pt-12 pb-20 md:pt-16 md:pb-32 flex flex-col items-center px-4" data-id="element-284">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="relative w-full max-w-[500px] mb-10" data-id="element-285">
        <img src="https://cdn.magicpatterns.com/uploads/qmwBa2tP2vciePEfbWYRRk/top_notch_logga.png" alt="Top Notch Bakery Logo" className="w-full h-auto object-contain drop-shadow-sm" data-id="element-286" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.2,
      ease: 'easeOut'
    }} className="text-center mb-10 max-w-2xl px-4" data-id="element-287">
        Hos oss hittar du nybakat bröd, kreativa bakverk och vällagad mat –
        alltid gjort från grunden. Vi drivs av nyfikenhet, hantverksskicklighet
        och en genuin kärlek till det vi skapar.
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.4,
      ease: 'easeOut'
    }} className="flex flex-col sm:flex-row items-center gap-4 w-full max-w-md justify-center mb-20 md:mb-32" data-id="element-288">
        <button onClick={onScrollToCatalog} className="w-full sm:w-auto px-8 py-3.5 bg-[#C4993D] text-[#F2EDE4] rounded-full font-medium text-sm hover:bg-[#A8832F] transition-colors shadow-sm" data-id="element-289">
          Förbeställning
        </button>
        <button onClick={onBusinessOrder} className="w-full sm:w-auto px-8 py-3.5 bg-transparent border-2 border-[#C4993D] text-[#C4993D] rounded-full font-medium text-sm hover:bg-[#C4993D]/10 transition-colors" data-id="element-290">
          Företagsbeställning
        </button>
      </motion.div>

      {/* Editorial Image Grid */}
      <div className="w-full max-w-5xl grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-start" data-id="element-291">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6,
        ease: 'easeOut'
      }} className="w-full" data-id="element-292">
          <img src="https://cdn.magicpatterns.com/uploads/fKFpEdf5PFAj8HiGFNH4Ae/0AC39895-57D5-4F1D-BFC8-B4D1341FF8F6.png" alt="Top Notch Bakery Counter" className="w-full aspect-[3/4] object-cover rounded-2xl shadow-lg border border-[#7C8062]/10" data-id="element-293" />
        </motion.div>

        <div className="w-full flex flex-col gap-6 md:gap-8 md:mt-16" data-id="element-294">
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.8,
          ease: 'easeOut'
        }} data-id="element-295">
            <img src="https://cdn.magicpatterns.com/uploads/fydJovVoiB1VDRERSZCu7c/77E18535-8EC5-4A5D-842C-07BE6F7121F8.png" alt="Top Notch Bakery Chocolate Display" className="w-full aspect-[4/3] object-cover rounded-2xl shadow-lg border border-[#7C8062]/10" data-id="element-296" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 1.0,
          ease: 'easeOut'
        }} data-id="element-297">
            <img src="https://cdn.magicpatterns.com/uploads/uqyo82xEXsx7htA4oPJVbw/8D11E304-9909-41BA-83B2-2DFA1C7F7BBD.png" alt="Top Notch Bakery Kanelbullar & Munkar" className="w-full aspect-[4/3] object-cover rounded-2xl shadow-lg border border-[#7C8062]/10" data-id="element-298" />
          </motion.div>
        </div>
      </div>
    </header>;
}